<template>
<div class="container">
    <div class="row d-flex justify-content-end">

        <div class="col-12 mb-4">
            <h3 class="c-ndarkthree bold d-flex align-items-center">
                <AssignorIcon :color="getPrimaryColorHex.four" />Cedentes
            </h3>
            <p class="c-ndarkfour">
                Visualize todos os cedentes com cadastro aprovado pela {{ getWhiteLabel | capitalizeFirstLetter }}.
            </p>
        </div>
        <div class="col-12 d-flex align-items-center justify-content-between">
            <TabProvider class="col-6" @tabSelect="handleTabChange($event)" />
            <div class="row">
                <SponsorsProviderBuyerFilter 
                    :filters="filters"
                    @updateFilter="updateFilter($event); getAllProviders()"
                    @empty="updateFilter($event); getAllProviders()"
                />
                <div class="ml-2">
                    <el-input  
                        @keyup.native.enter="getAllProviders" 
                        placeholder="Buscar" 
                        v-model="filterSearch"  
                        :class="`${getPrimaryColor} filter`" 
                        clearable
                        @clear="getAllProviders"
                    >
                        <button class="btn" slot="append" @click="getAllProviders">
                            <SearchIcon class="mx-0" size="16" />
                        </button>
                    </el-input>
                    <h6 slot="append" class="regular">
                        Busque pelo nome do cedente. Ex.: <span :class="`c-${getPrimaryColor}four`"> Cedente. </span>
                    </h6>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2 pt-1">
        <div class="col-12">
            <TableLoading v-if="isLoading" rowHeight="56" class="mt-3"/>
            <Provider v-else-if="providers.length" :tableData="providers" @classificationChange="getGroups()" />
            <NotFound v-else-if="filterSearch"/>
            <EmptyPage :button="false" title="Ainda não há cedentes nessa classificação!" v-else-if="!providers.length">
                Por enquanto, não há cedentes nessa classificação.
            </EmptyPage>
            <EmptyProvider v-else/>
        </div>
    </div>
    <el-skeleton v-if="isLoading" style="width: 45%; height: 40px; float:right; margin-top: 10px; " animated>
        <template slot="template">
            <el-skeleton-item variant="rect" style="width: 45%; height: 40px; float:right; margin-top: 10px; " />
        </template>
    </el-skeleton>
    <PaginationButtons v-else
        :pagination="pagination"
        @next="paginationNextAndPrev($event)" 
        @prev="paginationNextAndPrev($event)"
        :multiply="multiply"
    />
</div>
</template>

<script>
// Libraries
import _ from 'lodash'

// APIs
import getSponsorRejectedProviders from '@/api/getSponsorRejectedProviders'
import getAllProviders from '@/api/getAllProviders'

// Icons
import AssignorIcon from '@/components/icons/Assignor'

// Misc
import PaginationButtons from '@/components/pagination/PaginationButtons'
import Provider from '@/components/tables/Provider'
import EmptyProvider from '@/components/emptyOrNotFound/EmptyProvider'
import NotFound from '@/components/emptyOrNotFound/NotFound'
import TableLoading from '@/components/loading/TableLoading'
import TabProvider from '@/components/tabs/TabProvider'
import EmptyPage from '@/components/emptyOrNotFound/EmptyPage'
import SponsorsProviderBuyerFilter from '@/components/filters/SponsorsProviderBuyerFilter.vue'

// Utils
import { FILTERS } from '@/utils/constants';

// Vars
const FILTERS_USED = ['withECPF', 'totalValue']

export default {
    components: {
        Provider,
        AssignorIcon,
        EmptyProvider,
        NotFound,
        TableLoading,
        PaginationButtons,
        TabProvider,
        EmptyPage,
        SponsorsProviderBuyerFilter,
    },
    data() {
        return {
            filters: _.pick(FILTERS, FILTERS_USED),
            filterSearch: '',
            providers: [],
            page: 1,
            isLoading: false,
            multiply: 20,
            rejectedProviders: [],
            activeTab: this.$store.state.tabs.providerTab,
            pagination: {},
        }
    },
    watch: {
        filterSearch(val) {
            if (!val.length) {
                this.getAllProviders()
            }
        }
    },
    methods: {
        async getAllProviders() {
            this.isLoading = true
            
            await getAllProviders({
                search: this.filterSearch,
                maxOrderValue: this.filters.totalValue.maxValue,
                minOrderValue: this.filters.totalValue.minValue,
                page: this.page,
                excludeIds: this.activeTab == 1 ? true :
                            this.activeTab == 2 ? false :
                            null,
                ids: this.activeTab == 1 || this.activeTab == 2 ? this.rejectedProviders.join(',') : null,
                ...this.filtersAPI,
                bySponsor: true,
                
            })

            this.pagination = this.$store.state.companies.providers.pagination
            this.providers = this.$store.state.companies.providers.rows
            
            this.isLoading = false
            
        },

        async paginationNextAndPrev(page) { 
            this.page = page
            this.isLoading = true
            await this.getAllProviders()
            this.isLoading = false 
        },
        async handleClassificationChange({ provider, isRejected }) {
            if (isRejected == true) {
                this.rejectedProviders.push(provider.id)
            } else {
                this.rejectedProviders = this.rejectedProviders.filter((rejectedId) => rejectedId != provider.id)
            }
            await this.getAllProviders()
        },
        async handleTabChange(selectedTab) {
            this.activeTab = selectedTab
            await this.getAllProviders()
        },
        updateFilter(filter){
            this.filters = filter
            this.page = 1
        },
        async getGroups(){
            this.isLoading = true
            this.rejectedProviders = await getSponsorRejectedProviders(this.$store.state.user.cnpjId)
            await this.getAllProviders()
            this.isLoading = false
        }
    },
    computed: {
        filtersAPI() {
            const { filters, page } = this
            return this.formatFilteredAPIMixin({filters, setPagination: page}) 
        }
    },
    async created() {
        await this.getGroups()
        
    }

}
</script>

<style lang="scss" scoped>

</style>
